import { JobService } from './../../../../shared/API-Service/services/job.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-insert-job',
  templateUrl: './insert-job.component.html',
  styleUrls: ['./insert-job.component.css']
})
export class InsertJobComponent implements OnInit {
  insertForm: FormGroup;
  update: boolean = false;
  submit: boolean = true;
  validated: boolean;
  // job = new Job();
  inactive: boolean=true;

  private subscription = new Subscription();
  constructor(
    private fb: FormBuilder,
    private _jobService: JobService,
    private _router: Router,
    private translate: TranslateService,
    private readonly _activatedRoute: ActivatedRoute
  ) { }

  get fc() {
    return this.insertForm.controls;
  }

  ngOnInit(): void {
    this.initiate()
    this.checkEdit();
  }

  private checkEdit() {
    if (typeof this._activatedRoute.snapshot.params["id"] !== "undefined") {
      let id = this._activatedRoute.snapshot.params["id"];
      id !== null ? this.GetJobById(id) : this.initiate();
    } else
      this.initiate()
  }

  private initiate(jop?: any) {
    this.insertForm = this.fb.group({
      title: [jop?.title || '', Validators.required],
      description: [jop?.description || '', Validators.required],
    });
  }
  inactiveChange(){
    if(this.inactive){
      this.inactive=false;
    }
    else{
          this.inactive=true;
    }   
  }
  public onSubmit() {
    if (this.insertForm.status == "VALID") {
      this.validated = false;
      if (this.update == true) {
        this.Update();
      } else {
        this.insertData();
      }
    } else {
      this.validated = true;
      this.insertForm.markAllAsTouched()
    }
  }

  private insertData() {
    this.submit = false
    this.insertForm.addControl("inactive", new FormControl(this.inactive));
    this.subscription.add(this._jobService.Post(this.insertForm.value).subscribe((res) => {
      if (res.success === true) {
        this.insertForm.reset();
        Swal.fire({
          icon: "success",
          title: this.translate.instant("Inserted Success"),
          showConfirmButton: false,
          timer: 1500,
        });
        this._router.navigate(["/content/admin/List-Job"]);
      }
    }, (err) => {
      this.submit = true
    }
    ));
  }
  private Update() {
    this.submit = false
    this.insertForm.addControl("inactive", new FormControl(this.inactive));
    this.subscription.add(this._jobService.put(this.insertForm.value).subscribe((res) => {
      if (res.success === true) {
        this.insertForm.reset();
        Swal.fire({
          icon: "success",
          title: this.translate.instant("Updated Success"),
          showConfirmButton: false,
          timer: 1500,
        });
        this._router.navigate(["/content/admin/List-Job"]);
      }
    }, (err) => {
      this.submit = true
    }
    ));
  }


  private GetJobById(id: number): any {
    this.subscription.add(this._jobService.GetJobById(id).subscribe((res) => {
      if (res.message == "Sucess")
        this.initiate(res.data);
      this.update = true;
      this.inactive=res.data.inactive
      this.insertForm.addControl("id", new FormControl(id));
    }));
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }
}